import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'

const styles = theme => ({
  gridRoot: {
    width: 'calc(100% - 24px)',
    margin: '24px auto',
  },
})

class Page extends React.Component {
  render() {
    const { classes, theme, spacing, windowWidth } = this.props
    var rootGridProp
    var maxWidth = this.props.pageMaxWidth ? this.props.pageMaxWidth : '1200px'
    if (windowWidth >= theme.breakpoints.values.md) {
      rootGridProp = {
        spacing: spacing ? spacing : 8,
        style: { marginTop: theme.spacing.unit * 14, maxWidth }
      }
    }
    else if (windowWidth >= theme.breakpoints.values.sm) {
      rootGridProp = {
        spacing: spacing ? spacing : 8,
        style: { marginTop: theme.spacing.unit * 11, maxWidth }
      }
    }
    else {
      rootGridProp = {
        spacing: spacing ? spacing : 0,
        style: { marginTop: theme.spacing.unit * 7, maxWidth }
      }
    }
    return (
      <Grid container className={classes.gridRoot} {...rootGridProp}>
        {this.props.children}
      </Grid>
    )
  }
}

export default withStyles(styles, { withTheme: true })(Page)



// WEBPACK FOOTER //
// ./src/Parts/Page/components/Page.js